module.exports = "\r\ntitleheading{\r\n    background: red;\r\n    color:#000;\r\n    font-size:18px;\r\n    padding: 10px;\r\n    margin-top:5px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/employee-sr-view/employee-sr-view.component.css
// module id = ./src/app/hrms/employee-sr-view/employee-sr-view.component.css
// module chunks = main